// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import StyledDocumentSelectorOption from "./StyledDocumentSelectorOption-APP_CLIENT.styled";

export interface StyledDocumentSelectorOptionProps {
  selected: boolean;
}

export default StyledDocumentSelectorOption;
